import React, { MouseEvent } from 'react';
import styled from '@emotion/styled';
import { DropdownButton } from '../DropdownButton';
import InfoBubble from '../InfoBubble';
import styles from './styles.sass';

const Info = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  margin: 0;
  padding: 0;
  border-radius: 7px;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  background-color: #c9cbcd;
  cursor: pointer;
  &:hover {
    background: #c7c7c7;
  }
`;

type Props = {
  direction: string;
  children?: React.ReactNode;
  width: number;
  activeOnHover?: boolean;
  infoBubbleClassName?: string;
  infoButtonIconClassName?: string;
  ariaLabel?: string;
  preventBlur?: boolean;
  toggleComponent?: React.ReactNode;
};

// Info button that provides
const InfoButton = ({
  direction,
  children,
  width,
  activeOnHover,
  infoBubbleClassName = '',
  infoButtonIconClassName = '',
  ariaLabel,
  preventBlur = false,
  toggleComponent,
}: Props) => (
  <DropdownButton
    preventBlur={preventBlur}
    ariaLabel={ariaLabel}
    activeOnHover={activeOnHover}
    direction={direction}
    onClick={(e: MouseEvent) => e.stopPropagation()}
    dropdownComponent={
      <InfoBubble
        positionAgainstParent={false}
        className={`${styles.bubble} ${infoBubbleClassName}`}
        direction={direction}
        width={width}
      >
        {children}
      </InfoBubble>
    }
  >
    {toggleComponent || <Info className={infoButtonIconClassName}>i</Info>}
  </DropdownButton>
);

export default InfoButton;
